module.exports = __webpack_public_path__ + "img/mobileShieldBanner.e5028632.png";